export const createEnum = <T extends object>() => {
  return new Proxy(
    {},
    {
      get: (_, prop) => prop, // Whatever property you ask for, it returns the name as a string
    },
  ) as { readonly [K in keyof T]-?: K }; // Forces TypeScript to provide perfect autocomplete
};
